import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AssignParentToStudentModel } from 'data/manager/manager.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: AssignParentToStudentModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<AssignParentToStudentModel[]>> = (
  _,
  action,
) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const assignParentToStudentSlice = createSlice({
  name: 'assignParentToStudent',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default assignParentToStudentSlice;
